<template>
  <div v-if="visivel" class="modal is-active">

    <div class="modal-background" @click="fechar"></div>

    <div class="modal-card">
      <header class="modal-card-head has-background-primary">
        <p class="modal-card-title">
          Associe a Nota ao Plano de Contas
        </p>
        <button class="delete" aria-label="close" @click="fechar"></button>
      </header>

      <section class="modal-card-body">
        <table class="table is-fullwidth is-striped is-hoverable">
          <thead>
            <tr>
              <th>Conta do Plano de Contas</th>
              <th class="has-text-centered">Ação</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(nepc, index) in notasExplicativasPC" :key="nepc.id">
              <td>{{ nepc.plano_contas.descricao }}</td>
              <td class="has-text-centered">
                <button class="button is-small is-info is-outlined" @click="editarNota(index)" :disabled="habilitaLancamento">
                  <span class="icon is-small">
                    <i class="fas fa-edit"></i>
                  </span>
                </button>
                <button class="button is-small is-danger is-outlined" @click="excluirNota(index)" :disabled="habilitaLancamento">
                  <span class="icon is-small">
                    <i class="fas fa-trash"></i>
                  </span>
                </button>
              </td>
            </tr>

            <tr v-if="notasExplicativasPC.length === 0">
              <td colspan="3" class="has-text-centered has-text-grey">
                Nenhuma fórmula cadastrada para esta linha.
              </td>
            </tr>
          </tbody>
        </table>

        <div class="has-text-right mt-3">
          <button class="button is-success" @click="novaNota" :disabled="habilitaLancamento">
            Cadastrar
          </button>
        </div>

        <br/>

        <div class="card" v-if="habilitaLancamento">
          <header class="card-header">
            <p class="card-header-title">Edição</p>            
          </header>
        
          <div class="card-content">
            <form class="is-fullwidth">
              <div class="field is-horizontal is-fullwidth">
                <div class="field-label is-normal">
                  <label class="label">Linha</label>
                </div>
                <div class="field-body">
                  <div class="field is-fullwidth">
                    <div class="control is-expanded">
                      <div class="select is-fullwidth">
                        <select v-model="notaExplicativaPC.plano_contas" class="is-fullwidth">
                          <option v-for="pc in planoContas" :key="pc.id" :value="pc">
                            {{ pc.conta_contabil + " - " + pc.descricao }}
                          </option>
                        </select>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </form>
          </div>

          <footer class="card-footer">
            <button class="button is-success" @click="save">Salvar</button>
            <button class="button" v-on:click="habilitaLancamento = false">Cancelar</button>
          </footer>
        </div>
      </section>
      
    </div>
  </div>
</template>

<script>
import { http } from '../../services/config';

export default {
  name: "notaExplicativaPC",
  props: {
    visivel: {
      type: Boolean,
      required: true,
    },
    linha: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      notaExplicativaPC: {
          id: null,
          plano_contas: null,
          nota_explicativa_nota: null,
      },
      notasExplicativasPC: [],
      planoContas: [],
      habilitaLancamento: false
    };
  },
  watch: {
    linha(novaLinha) {
      if (novaLinha && novaLinha.id) {
        this.carregarNotas();
      }
    },
    visivel(novoValor) {
      if (novoValor && this.linha?.id) {
        this.carregarNotas();
      }
    }
  },
  methods: {
    clearFields: function() {
      this.notaExplicativaPC = {
        id: null,
        nota_explicativa_nota: parseInt(this.linha.id),
        plano_contas: null,
        index: null
      }
    },

    save: function() {
      var data

      if (this.notaExplicativaPC.plano_contas == null) {
           alert('Conta não selecionada!')
           return
       }

      data = {id: this.notaExplicativaPC.id,
          plano_contas: this.notaExplicativaPC.plano_contas.id,
          nota_explicativa_notas: this.linha.id
      }

      if (this.notaExplicativaPC.id == null) {
          http.post('/notaExplicativa/adicionarNotasPlanoContas', data).then(response =>{
              if (response.data.id != undefined && response.data.id != '') {
                  this.notaExplicativaPC.id = response.data.id
                  this.notasExplicativasPC.push(this.notaExplicativaPC)
                  this.clearFields()
              } else {
                  alert(response.request.responseText)
              }
          }).catch(e => {
              alert(e.response.data);
              return
          })
      } 
      else {
          http.put('/notaExplicativa/editarNotasPlanoContas/'+this.notaExplicativaPC.id, data).then(response =>{
              this.notasExplicativasPC[this.notaExplicativaPC.index].id = response.data.id
              this.notasExplicativasPC[this.notaExplicativaPC.index].plano_contas = this.notaExplicativaPC.plano_contas
          }).catch(e => {
              alert(e.response.data);
              return
          })
      }                    

    },

    async carregarNotas() {
      if (!this.linha || !this.linha.id) return;

      try {
        const response = await http.get(`/notaExplicativa/listarNotasPlanoContas/`, {
          params: { idNotaExplicativa: parseInt(this.linha.id) }
        });
        this.notasExplicativasPC = response.data.results;
      } catch (error) {
        console.error("Erro ao carregar as associações com o plano de contas:", error);
        alert("Não foi possível carregar as associações com o plano de contas. Verifique a linha selecionada ou tente novamente.");
      }
    },

    async novaNota() {
      this.habilitaLancamento = true
      this.clearFields()
    },

    async editarNota(index) {
      this.habilitaLancamento = true
      this.notaExplicativaPC.id = this.notasExplicativasPC[index].id
      this.notaExplicativaPC.nota_explicativa_nota = parseInt(this.linha.id)
      this.notaExplicativaPC.plano_contas = this.notasExplicativasPC[index].plano_contas
      this.notaExplicativaPC.index = index
    },

    async excluirNota(index) {
      if (window.confirm('Confirma exclusão?')) {
        http.delete('/notaExplicativa/excluirNotasPlanoContas/'+this.notasExplicativasPC[index].id).then(response =>{
            this.notasExplicativasPC.splice(index, 1)
            if (response.status == 204) {
                alert('Registro excluído!')
            }
        }).catch(e => {
            console.log(e);
        })
      }
    },

    fechar() {
      this.$emit("fechar");
    },

  },

  mounted() {
    http.get('versoesPlanoContas/listarPlanoContas/', {
        params: { idVersaoPlanoContas: this.linha.nota_explicativa_periodo.perfil.versao_plano_contas,
            idPerfil: this.linha.nota_explicativa_periodo.perfil.id },
      }).then(response => {
        this.planoContas = response.data.results;
      })
      .catch(error => {
        console.error("Erro ao carregar planos de contas:", error);
      });

      this.carregarNotas()
  }
};
</script>
